import axios from "../utils/axios";

export const getHaystackersBlogCategories = async () => {
  try {
    const response = await axios.get("/admin/haystackers-blog-categories");
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch blog categories",
    );
  }
};

export const createHaystackersBlogCategory = async (categoryData) => {
  try {
    const response = await axios.post(
      "/admin/haystackers-blog-categories",
      categoryData,
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to create blog category",
    );
  }
};

export const updateHaystackersBlogCategory = async (categoryId, categoryData) => {
  try {
    const response = await axios.put(
      `/admin/haystackers-blog-categories/${categoryId}`,
      categoryData,
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to update blog category",
    );
  }
};

export const deleteHaystackersBlogCategory = async (categoryId) => {
  try {
    const response = await axios.delete(
      `/admin/haystackers-blog-categories/${categoryId}`,
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to delete blog category",
    );
  }
};

export const getHaystackersBlogCategoriesByBlogId = async (blogId) => {
  try {
    const response = await axios.get(
      `/admin/haystackers-blogs/${blogId}/categories`,
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        "Failed to fetch categories for blog",
    );
  }
};

export const setHaystackersBlogCategories = async (blogId, categoryIds) => {
  try {
    const response = await axios.put(
      `/admin/haystackers-blogs/${blogId}/categories`,
      { categoryIds },
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to set blog categories",
    );
  }
};
